import {
  FeatureFlag,
  useFeatureFlag,
} from "@vega-api/extended/auth/useFeatureFlag";
import {
  useListCmsFaqsV2,
  usePreviewCmsFaqsV2,
} from "@vega-api/generated/cms-faqs/cms-faqs";
import { type FaqCategoryV2 } from "@vega-api/generated/types/faqCategoryV2";
import { type FaqPlacement } from "@vega-api/generated/types/faqPlacement";

const PAGE_SIZE = 50;

export function useCmsFaqs(placement: FaqPlacement, impersonationId?: string) {
  const { featureFlag } = useFeatureFlag();
  const isFlagEnabled = featureFlag[FeatureFlag.VEGA_CMS_MIGRATION];
  const isPreview = !!impersonationId;

  const standard = useListCmsFaqsV2(
    { placement, pageSize: PAGE_SIZE },
    {
      query: {
        enabled: isFlagEnabled && !isPreview,
        select: (response): FaqCategoryV2[] => response.data,
      },
    },
  );

  const preview = usePreviewCmsFaqsV2(
    { impersonationId: impersonationId ?? "", placement, pageSize: PAGE_SIZE },
    {
      query: {
        enabled: isFlagEnabled && isPreview,
        select: (response): FaqCategoryV2[] => response.data,
      },
    },
  );

  const active = isPreview ? preview : standard;

  return {
    isFlagEnabled,
    faqCategories: active.data,
    isLoading: active.isLoading,
    isError: active.isError,
  };
}
